export const DEFAULT_PAGE_PATH = 'index'
